<template>
  <h1 class="title">{{ title }}</h1>
</template>

<script>
export default {
  name: "AccountHeader",

  props: {
    title: { type: String, required: true },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: var(--typography-font-family-text-primary);
  font-weight: var(--typography-font-weight-fw-700);
  font-size: var(--typography-font-size-fs-500);
  line-height: 24px;
  letter-spacing: 0;
  vertical-align: bottom;
}
</style>
